export default class MikomiData
{
    constructor()
    {
        this.sales_figures = 0;
        this.provProfit_figures = 0;
        this.provProfit_rate_figures = 0;
        this.sales_plastic = 0;
        this.provProfit_plastic = 0;
        this.provProfit_rate_plastic = 0;
        this.sales_digital = 0;
        this.provProfit_digital = 0;
        this.provProfit_rate_digital = 0;
        this.sales_xpna = 0;
        this.provProfit_xpna = 0;
        this.provProfit_rate_xpna = 0;
        this.sales = 0;
        this.provProfit = 0;
        this.provProfit_rate = 0;
        // 総益
        this.grossOperatingProfit = 0;
        this.operatingProfit = 0;
        this.operatingProfit_rate = 0;
        this.netIncome = 0;
        this.stock = 0;
    }

    Add(otherMikomiData)
    {
        for (const key in this)
        {
            if (Object.hasOwn(otherMikomiData, key) === true &&
                typeof this[key] !== typeof 'string' &&
                key !== 'month')
            {
                this[key] += otherMikomiData[key];
            }
        }

        for (const key in otherMikomiData)
        {
            if (Object.hasOwn(this, key) === false &&
                typeof otherMikomiData[key] !== typeof 'string' &&
                key !== 'month')
            {
                this[key] = otherMikomiData[key];
            }
        }

        this.provProfit_rate_figures = this.sales_figures !== 0 ? this.provProfit_figures / this.sales_figures * 100 : 0;
        this.provProfit_rate_plastic = this.sales_plastic !== 0 ? this.provProfit_plastic / this.sales_plastic * 100 : 0;
        this.provProfit_rate_digital = this.sales_digital !== 0 ? this.provProfit_digital / this.sales_digital * 100 : 0;
        this.provProfit_rate = this.sales !== 0 ? this.provProfit / this.sales * 100 : 0;
        this.operatingProfit_rate = this.sales !== 0 ? this.operatingProfit / this.sales * 100 : 0;
    }
}